import type {
  TeamPlayerFinderPosition,
  TeamPlayerFinderRegistration,
} from '../types'

/**
 * "Fall League 2026 · Men's C" — the competition an ad runs in, then the
 * division this registration belongs to. Either half is dropped when the server
 * could not resolve it, so a label is never "undefined · Men's C".
 */
export const playerFinderRegistrationLabel = (
  entry: TeamPlayerFinderRegistration
): string =>
  [entry.competition?.name, entry.division?.name]
    .filter((part): part is string => Boolean(part && part.trim()))
    .join(' · ')

/** A position's readable name: `name_full` ("Forward") before the short code. */
export const playerFinderPositionName = (
  position: TeamPlayerFinderPosition
): string =>
  position.name_full || position.name || position.abbreviation || position.id

/**
 * The positions an ad asks for, readably. Empty means "any player", which the
 * caller renders in its own words — this returns null for it rather than
 * inventing copy in shared code.
 */
export const playerFinderPositionsSummary = (
  positions: readonly TeamPlayerFinderPosition[]
): string | null =>
  positions.length > 0
    ? positions.map(playerFinderPositionName).join(', ')
    : null
